import AdNetworkSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/AdNetworkSignalSubType";
import {
    COLUMN_AD_NETWORKS_ADDED_NAME,
    COLUMN_AD_NETWORKS_REMOVED_NAME,
} from "app/pages/sales-intelligence/sub-modules/signals/constants/column-names";

export const AD_NETWORK_SUBTYPE_BY_COLUMN_NAME = {
    [COLUMN_AD_NETWORKS_REMOVED_NAME]: AdNetworkSignalSubType.RemovedAdNetworks,
    [COLUMN_AD_NETWORKS_ADDED_NAME]: AdNetworkSignalSubType.AddedAdNetworks,
};
